<template>
  <van-tabbar :model-value="active" fixed safe-area-inset-bottom :z-index="10">
    <van-tabbar-item name="home" @click="onTabClick('home')">
      <template #icon>
        <van-icon name="wap-home-o" size="22" />
      </template>
      首页
    </van-tabbar-item>
    <van-tabbar-item name="ranking" @click="onTabClick('ranking')">
      <template #icon>
        <van-icon name="chart-trending-o" size="22" />
      </template>
      转介绍榜
    </van-tabbar-item>
    <van-tabbar-item name="mine" @click="onTabClick('mine')">
      <template #icon>
        <van-icon name="user-o" size="22" />
      </template>
      我的
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const active = ref('home')

// 监听路由变化，同步 tab 状态
watch(() => route.path, (path) => {
  if (path === '/mine') {
    active.value = 'mine'
  } else if (path === '/referral/ranking') {
    active.value = 'ranking'
  } else {
    active.value = 'home'
  }
}, { immediate: true })

function onTabClick(name) {
  const targetMap = { home: '/', ranking: '/referral/ranking', mine: '/mine' }
  const targetPath = targetMap[name]
  if (route.path !== targetPath) {
    router.push(targetPath)
  }
}
</script>

<style scoped>
:deep(.van-tabbar) {
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
}

:deep(.van-tabbar-item--active) {
  color: #1677ff;
}

:deep(.van-tabbar-item--active .van-icon) {
  color: #1677ff;
}

:deep(.van-tabbar-item__icon) {
  font-size: 22px;
}

:deep(.van-tabbar-item__text) {
  font-size: 12px;
}
</style>
